// @ts-check
// Leitura de CSV para a importação de planilhas. Aceita o que o Excel em pt-BR grava (";" e BOM), o padrão
// internacional (",") e TSV; o separador é escolhido pela primeira linha, fora de aspas.

const BYTE_ORDER_MARK = '﻿';
const CANDIDATE_SEPARATORS = [';', ',', '\t', '|'];
// a exportação do appcrm protege fórmulas com um apóstrofo (ou ZWJ no Twenty); na volta, o prefixo sai
const FORMULA_GUARD_PATTERN = /^(?:'|‍)(?=[=+\-@])/;

/**
 * Separador mais frequente na primeira linha com conteúdo, ignorando trechos entre aspas.
 * @param {string} text
 */
export function detectCsvSeparator(text) {
  const firstLineEnd = text.search(/\r?\n/);
  const firstLine = firstLineEnd === -1 ? text : text.slice(0, firstLineEnd);
  const outsideQuotes = firstLine.replace(/"[^"]*"/g, '');
  let best = ';';
  let bestCount = 0;
  for (const separator of CANDIDATE_SEPARATORS) {
    const count = outsideQuotes.split(separator).length - 1;
    if (count > bestCount) {
      best = separator;
      bestCount = count;
    }
  }
  return best;
}

/** @param {string} cell */
export function cleanImportedCell(cell) {
  return cell.replace(FORMULA_GUARD_PATTERN, '');
}

/**
 * CSV em linhas de células (texto). Linhas totalmente vazias são descartadas, como o `blankrows: false` do Twenty.
 * @param {string} input
 * @param {{ separator?: string }} [options]
 * @returns {string[][]}
 */
export function parseCsv(input, options = {}) {
  const text = input.startsWith(BYTE_ORDER_MARK) ? input.slice(1) : input;
  const separator = options.separator ?? detectCsvSeparator(text);
  /** @type {string[][]} */
  const rows = [];
  /** @type {string[]} */
  let row = [];
  let cell = '';
  let inQuotes = false;
  let index = 0;
  const pushCell = () => {
    row.push(cleanImportedCell(cell));
    cell = '';
  };
  const pushRow = () => {
    pushCell();
    if (row.some((value) => value.trim() !== '')) rows.push(row);
    row = [];
  };
  while (index < text.length) {
    const character = text[index];
    if (inQuotes) {
      if (character === '"') {
        if (text[index + 1] === '"') {
          cell += '"';
          index += 2;
          continue;
        }
        inQuotes = false;
        index += 1;
        continue;
      }
      cell += character;
      index += 1;
      continue;
    }
    if (character === '"' && cell.trim() === '') {
      inQuotes = true;
      cell = '';
      index += 1;
      continue;
    }
    if (character === separator) {
      pushCell();
      index += 1;
      continue;
    }
    if (character === '\r' || character === '\n') {
      pushRow();
      index += character === '\r' && text[index + 1] === '\n' ? 2 : 1;
      continue;
    }
    cell += character;
    index += 1;
  }
  if (cell !== '' || row.length > 0) pushRow();
  return rows;
}
